import { SALES_FUNNELS_SETTINGS_API } from 'modules/profile/sales-funnels-settings/api/sales-funnels-settings-api'
import { SalesFunnelsSettingsInterface } from 'modules/profile/sales-funnels-settings/types/sales-funnels-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useSalesFunnelsSettings() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, SalesFunnelsSettingsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: salesFunnelData, mutate } = useSWR(() => {
    if (user) {
      return SALES_FUNNELS_SETTINGS_API
    }
    return null
  }, fetcher)
  return { salesFunnelData, mutate }
}
